"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InvestorProfileDisclosureModal;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function InvestorProfileDisclosureModal(_ref) {
  var {
    handleClose,
    show,
    disclosureTitle
  } = _ref;
  /* The disclosureTitle prop is optional; if disclosureTitle is not defined in ModalChargePageTwo.js and a disclosureTitle prop is not passed from ModalChargePageTwo.js in the <ModalChargeDisclosureModal> call, 
    then the disclosure modal title will render "Disclosure & Assumptions" as a default title */

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: disclosureTitle ? disclosureTitle : 'Disclosure & Assumptions'
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("p", null, "In applying particular asset allocation models to your individual selection, you should consider your other assets, income and investments (e.g. equity in a home, Social Security benefits, individual retirement plan investments, savings accounts, and interests in other qualified and non-qualified plans) in addition to your interests in this plan. Any investment profile results included in these materials are not intended to be investment advice or recommendations to you and may or may not be appropriate for your circumstances."), /*#__PURE__*/_react.default.createElement("p", null, "The above investment charts were designed by MassMutual and do not represent a recommendation or endorsement of any particular investment or investment style. Past performance does not guarantee future results."), /*#__PURE__*/_react.default.createElement("p", null, "Please consider an investment option's objectives, risks, fees and expenses carefully before investing."))))));
}